import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  Button,
  Container,
  DataGridButton,
  Title,
  UserDeleteOptionsGreen,
  UserDeleteOptionsRed,
} from "./styles";
import { Alert, AlertColor, Avatar, Checkbox, Snackbar } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { UserPermissions } from "../../App";
import { Link } from "@mui/joy";

interface Props {
  userPermissions: UserPermissions;
}
const Patients: React.FC<Props> = ({ userPermissions }) => {
  const navigate = useNavigate();

  const [userDelete, setUserDelete] = useState("");

  const [showStatus, setShowStatus] = React.useState(false);
  const [statusMsg, setStatusMsg] = React.useState("");
  const [statusSeverity, setStatusSeverity] =
    React.useState<AlertColor>("error");
  const handleCloseStatus = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setShowStatus(false);
  };
  const showStatusMessage = (message: string, status: AlertColor) => {
    setStatusMsg(message);
    setStatusSeverity(status);
    setShowStatus(true);
  };

  const deleteUser = (username: string) => {
    console.log("Delete: ", username);
    fetch("/api/v1/patient/delete", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: username,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        getUsers();
        if (data.success === true) {
          showStatusMessage(`User '${username} was deleted.`, "success");
        } else {
          showStatusMessage(
            `User '${username} was not deleted: ${data.reason + ""}`,
            "error"
          );
        }
      })
      .catch((err) => {
        console.log("Cannot delete patient:", err);
        showStatusMessage(
          `User '${username} was not deleted: Unkown Error`,
          "error"
        );
      });
  };

  const columns = [
    {
      field: "patientCallURL",
      headerName: "Remote Therapy",
      width: 180,
      renderCell: (params: any) => (
        <>
          <Checkbox
            size="small"
            checked={
              typeof params.row.patientCallURL === "string" &&
              params.row.patientCallURL.length > 0
            }
            onChange={function (event: React.ChangeEvent<HTMLInputElement>) {
              console.log("DATA:", params.row);
              editUser({
                username: params.row.username.username,
                canJoinMeeting: !(
                  typeof params.row.patientCallURL === "string" &&
                  params.row.patientCallURL.length > 0
                ),
              });
            }}
          />
          {typeof params.row.patientCallURL === "string" &&
            params.row.patientCallURL.length > 0 && (
              <Link rel="noreferrer" href={params.row.patientCallURL}>
                Open Meeting
              </Link>
            )}
        </>
      ),
    },
    {
      field: "username",
      headerName: "Username",
      width: 150,
      renderCell: (params: any) => (
        <>
          <Avatar
            src={params.value.photo}
            sx={{ height: "2rem", width: "2rem", marginRight: "1rem" }}
          />{" "}
          {params.value.username}
        </>
      ),
    },
    {
      field: "name",
      headerName: "Name",
      width: 200,
    },
    {
      field: "id",
      headerName: "Email",
      width: 240,
    },
    {
      field: "age",
      headerName: "Age",
      width: 30,
    },
    {
      field: "language",
      headerName: "Language",
      width: 80,
    },
    {
      field: "clinician",
      headerName: "Clinician",
      width: 80,
    },
    {
      field: "verified",
      headerName: "Verified",
      width: 70,
      renderCell: (params: any) => (
        <Checkbox
          {...{
            inputProps: { "aria-label": "Checkbox demo" },
          }}
          size="small"
          checked={params.value}
          onChange={function (event: React.ChangeEvent<HTMLInputElement>) {
            editUser({
              username: params.row.username.username,
              isEmailVerified: !params.value,
            });
          }}
        />
      ),
      /*renderCell: (params: any) => <span style={{
                  color: params.value === "Yes" ? "#2E933C" : "#DB3A34",
                  fontFamily: 'Roboto',
                  fontWeight: 900
              }}>{params.value}</span>*/
    },
    {
      field: "lastSeen",
      headerName: "Last Seen",
      width: 140,
      renderCell: (params: any) => {
        const d = new Date(params.value);
        const dformat =
          [d.getMonth() + 1, d.getDate(), d.getFullYear()].join("/") +
          " " +
          [String(d.getHours()).padStart(2, "0"), String(d.getMinutes()).padStart(2, "0")].join(":");
        return <span>{dformat}</span>;
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 450,
      renderCell: (params: any) => (
        <span style={{}}>
          <DataGridButton
            onClick={() => {
              navigate(
                process.env.PUBLIC_URL +
                  "/Patients/View/" +
                  params.row.username.username
              );
            }}
          >
            View
          </DataGridButton>
          <DataGridButton
            onClick={() => {
              navigate(
                process.env.PUBLIC_URL +
                  "/Patients/SoftwareList/" +
                  params.row.username.username
              );
            }}
          >
            Softwares
          </DataGridButton>
          {/*userPermissions.ORI.Admin !== true ? (
            ""
          ) :*/}
          {userDelete === params.row.username.username ? (
            <>
              Delete?{" "}
              <UserDeleteOptionsRed
                onClick={() => {
                  deleteUser(userDelete);
                  setUserDelete("");
                }}
              >
                Yes
              </UserDeleteOptionsRed>{" "}
              <UserDeleteOptionsGreen
                onClick={() => {
                  setUserDelete("");
                }}
              >
                No
              </UserDeleteOptionsGreen>
            </>
          ) : (
            <DataGridButton
              style={{ color: "#DB3A34", border: "2px solid #DB3A34" }}
              onClick={() => {
                setUserDelete(params.row.username.username);
              }}
            >
              Delete
            </DataGridButton>
          )}
        </span>
      ),
    },
  ];

  const [tableData, setTableData] = useState([]);

  const editUser = (params: {
    username: string;
    isEmailVerified?: boolean;
    canJoinMeeting?: boolean;
  }) => {
    console.log("To send: ", params);
    let toSend = params;
    fetch("/api/v1/patient/edit", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(toSend),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        getUsers();
      })
      .catch((err) => console.log("Cannot edit patient:", err));
  };

  function getUsers() {
    fetch("/api/v1/patient/all", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Data:", data);
        if (data.success === false) {
          setTableLoading(false);
          showStatusMessage(`Error: ${data.reason}`, "error");
          return;
        }

        data = data.map((user: any) => {
          return {
            canJoinMeeting: user.canJoinMeeting,
            patientCallURL: user.patientCallURL,
            username: {
              username: user.username,
              photo: user.logo,
            },
            name: `${user.firstName} ${user.lastName}`,
            id: user.email,
            age: user.birthDate,
            language: user.language,
            verified: user.isEmailVerified === 1,
            lastSeen: user.lastTimeOnline,
            clinician: user.clinician,
            action: "View Delete",
            isAdmin: user.isAdmin === 1 ? true : false,
            isResearcher: user.isResearcher === 1 ? true : false,
          };
        });
        console.log(data);
        setTableData(data);
        setTableLoading(false);
      })
      .catch((err) => {
        setTableLoading(false);
        showStatusMessage(`Error: Cannot fetch patient list`, "error");
        console.log("Cannot get patient list:", err);
      });
  }

  const [tableLoading, setTableLoading] = useState(false);
  useEffect(() => {
    setTableLoading(true);
    getUsers();

    const interval = setInterval(() => {
      getUsers();
    }, 5000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Title>
        Patients{" "}
        <Button
          onClick={() => {
            navigate(process.env.PUBLIC_URL + "/Patients/Create");
          }}
        >
          Add new patient
        </Button>
      </Title>

      <div style={{ height: 500, width: "100%", paddingTop: "1rem" }}>
        <DataGrid
          style={{ fontWeight: 900, color: "rgba(55, 73, 87, 0.7)" }}
          rows={tableData}
          columns={columns}
          disableColumnFilter
          disableColumnSelector
          disableDensitySelector
          components={{ Toolbar: GridToolbar }}
          componentsProps={{
            toolbar: {
              showQuickFilter: true,
              quickFilterProps: { debounceMs: 500 },
            },
          }}
          loading={tableLoading}
        />
      </div>

      <Snackbar
        open={showStatus}
        autoHideDuration={6000}
        onClose={handleCloseStatus}
      >
        <Alert
          onClose={handleCloseStatus}
          severity={statusSeverity}
          sx={{ width: "100%" }}
        >
          {statusMsg}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Patients;
